import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
export default function LegalBackToLogin() {
    return (_jsx("div", { "data-legal-back-to-login": "true", style: {
            display: "flex",
            justifyContent: "center",
            width: "100%",
            margin: "30px 0 8px",
        }, children: _jsx(Link, { to: "/login", "aria-label": "Back to Login", style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "220px",
                minHeight: "48px",
                boxSizing: "border-box",
                padding: "12px 22px",
                borderRadius: "14px",
                border: "1px solid color-mix(in srgb, var(--ava-face-accent, #16cfe0) 58%, transparent)",
                background: "linear-gradient(180deg, color-mix(in srgb, var(--ava-face-accent, #16cfe0) 15%, rgba(9,17,28,0.96)), rgba(2,6,12,0.97))",
                color: "var(--ava-text, #e7fbfd)",
                fontFamily: "Orbitron, system-ui, sans-serif",
                fontSize: "12px",
                fontWeight: 800,
                letterSpacing: "0.075em",
                textDecoration: "none",
                textTransform: "uppercase",
                boxShadow: "0 0 20px color-mix(in srgb, var(--ava-face-accent, #16cfe0) 20%, transparent)",
            }, children: "\u2039 Back to Login" }) }));
}
